// client/src/AdminDashboard.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from './firebase';
import AdminMembershipTab from './AdminMembershipTab';
import AdminRevenueTab from './AdminRevenueTab';
import AdminNumbersTab from './AdminNumbersTab';
import AdminCommunicationTab from './AdminCommunicationTab';
import AdminRolloutSetsTab from './AdminRolloutSetsTab';
import AdminUserInfoTab from './AdminUserInfoTab';
import AdminResendPanel from './AdminResendPanel';
import AdminOverviewTab from './AdminOverviewTab';
import AdminSocialTab from './AdminSocialTab';

const AdminDashboard = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('overview');

  const handleSignOut = async () => {
    try {
      await signOut(auth);
    } catch (err) {
      console.error('Sign-out failed:', err);
    }
    navigate('/');
  };

  let content;
switch (activeTab) {
  case 'overview':
    content = <AdminOverviewTab />;
    break;
  case 'membership':
      content = <AdminMembershipTab />;
      break;
 case 'revenue':
      content = <AdminRevenueTab />;
      break;
case 'numbers':
        content = <AdminNumbersTab />;
        break;
case 'communication':
        content = <AdminCommunicationTab />;
        break;
  case 'rollouts':
    content = <AdminRolloutSetsTab />;
    break;
  case 'userInfo':
    content = <AdminUserInfoTab />;
    break;
  case 'resend':
    content = <AdminResendPanel />;
    break;
  case 'social':
    content = <AdminSocialTab />;
    break;
  default:
    content = <div>Coming soon!</div>;
}

  return (
    <div style={{ display: 'flex', height: '100vh', fontFamily: 'Arial, sans-serif' }}>
      {/* Sidebar */}
      <div style={{ width: '250px', backgroundColor: '#333', color: '#fff', padding: '2rem 1rem' }}>
        <h2>LottoLogic Admin</h2>
        <div style={{ marginTop: '2rem', display: 'flex', flexDirection: 'column', gap: '1rem' }}>
          <button onClick={() => setActiveTab('overview')} style={buttonStyle}>Overview</button>
          <button onClick={() => setActiveTab('membership')} style={buttonStyle}>Membership</button>
          <button onClick={() => setActiveTab('revenue')} style={buttonStyle}>Revenue</button>
 <button onClick={() => setActiveTab('numbers')} style={buttonStyle}>Number Generation</button>
<button onClick={() => setActiveTab('communication')} style={buttonStyle}>Communication</button>
          <button onClick={() => setActiveTab('social')} style={buttonStyle}>Social Media</button>
          <button onClick={() => setActiveTab('rollouts')} style={buttonStyle}>Rollout Sets</button>
          <button onClick={() => setActiveTab('userInfo')} style={buttonStyle}>User Information</button>
          <button onClick={() => setActiveTab('resend')} style={buttonStyle}>Admin Tools</button>
        </div>
        <button onClick={handleSignOut} style={signOutStyle}>Sign Out</button>
      </div>

      {/* Main Content */}
      <div style={{ flex: 1, padding: '2rem', backgroundColor: '#f9f9f9' }}>
        {content}
      </div>
    </div>
  );
};

const buttonStyle = {
  padding: '0.75rem',
  backgroundColor: '#555',
  color: '#fff',
  border: 'none',
  borderRadius: '5px',
  fontSize: '1rem',
  cursor: 'pointer',
};

const signOutStyle = {
  marginTop: '2rem',
  padding: '0.75rem',
  backgroundColor: '#e74c3c',
  color: '#fff',
  border: 'none',
  borderRadius: '5px',
  fontSize: '1rem',
  cursor: 'pointer',
};

export default AdminDashboard;